import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const AgentTracingDetails = ({ tracingData }) => {
  // Function to get text color based on trace type
  const getTextColor = (trace) => {
    if (
      trace.orchestrationTrace?.modelInvocationInput?.type === "ORCHESTRATION"
    ) {
      return "#4caf50"; // green color for modelInvocationInput
    }
    return "inherit";
  };

  // Function to generate the summary text for each accordion item
  const getSummaryText = (trace) => {
    const traceObj = trace.orchestrationTrace;
    let traceId = "";
    let traceType = "";

    if (traceObj.modelInvocationInput) {
      traceId = traceObj.modelInvocationInput.traceId || "";
      traceType = "modelInvocationInput";
    } else if (traceObj.modelInvocationOutput) {
      traceId = traceObj.modelInvocationOutput.traceId || "";
      traceType = "modelInvocationOutput";
    } else if (traceObj.rationale) {
      traceId = traceObj.rationale.traceId || "";
      traceType = "rationale";
    } else if (traceObj.invocationInput) {
      traceId = traceObj.invocationInput.traceId || "";
      traceType = "invocationInput";
    } else if (traceObj.observation) {
      traceId = traceObj.observation.traceId || "";
      traceType = "observation";
    }

    // Extract ID part from traceId (assuming format like cfee94af-a263-4eb4-b1ce-2d57d7f685b3-0)
    const idParts = traceId.split("-");
    const shortId =
      idParts.slice(0, 5).join("-") +
      (idParts.length > 5 ? `-${idParts[5]}` : "");

    return `orchestrationTrace - ${shortId} - ${traceType}`;
  };

  return (
    <Paper elevation={1} sx={{ borderRadius: "8px", overflow: "hidden" }}>
      {tracingData.map((trace, index) => (
        <Accordion
          key={index}
          sx={{
            border: "none",
            boxShadow: "none",
            "&::before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
            sx={{
              borderBottom: "1px solid #e0e0e0",
              minHeight: "48px",
              px: 2,
            }}
          >
            <Typography
              color={getTextColor(trace)}
              sx={{ fontFamily: "monospace" }}
            >
              {getSummaryText(trace)}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ px: 2, py: 1 }}>
            <pre style={{ margin: 0, overflowX: "auto" }}>
              {JSON.stringify(trace.orchestrationTrace, null, 2)}
            </pre>
          </AccordionDetails>
        </Accordion>
      ))}
    </Paper>
  );
};

export default AgentTracingDetails;
